// import { ForestProductPriceHistory } from '../../../components/ForestProduct';

export function ForestProductPrices() {
  // This component has been hidden for now.
  // return <ForestProductPriceHistory />;
  return null;
}
